import conceptCardPrompts from '../../../concept-cards.json';

export type IdeaCard = {
  id: string;
  prompts: readonly string[];
};

function buildIdeaCards(value: unknown): IdeaCard[] {
  if (!Array.isArray(value) || value.length === 0) {
    throw new Error('Concept card data must contain at least one card');
  }

  return value.map((prompts, index) => {
    if (
      !Array.isArray(prompts) ||
      prompts.length !== 9 ||
      !prompts.every(
        (prompt): prompt is string =>
          typeof prompt === 'string' && prompt.trim().length > 0,
      )
    ) {
      throw new Error(`Concept card ${index + 1} must contain nine non-empty prompts`);
    }

    return {
      id: `concept-${String(index + 1).padStart(3, '0')}`,
      prompts: [...prompts],
    };
  });
}

// Cards are optional local inspiration and never represent an authoritative
// answer in room or server state.
export const IDEA_CARDS: readonly IdeaCard[] = buildIdeaCards(conceptCardPrompts);

export function drawIdeaCard(
  previousCardId?: string,
  random: () => number = Math.random,
): IdeaCard {
  const choices = IDEA_CARDS.filter(
    (card) => IDEA_CARDS.length === 1 || card.id !== previousCardId,
  );
  const index = Math.min(
    choices.length - 1,
    Math.floor(Math.max(0, random()) * choices.length),
  );
  const card = choices[index];
  if (!card) throw new Error('No idea cards are available');
  return card;
}
